import { useDispatch, useSelector } from 'react-redux';
import { getPushSubscriptionState } from './selectors';
import { useCallback } from 'react';
import { togglePushSubscription } from './actions';
import { PushSubscriptionState } from './types';
export function usePushSubscription() {
    const state = useSelector(getPushSubscriptionState);
    const dispatch = useDispatch();
    const toggleSubscription = useCallback(()=>{
        dispatch(togglePushSubscription());
    }, [
        dispatch
    ]);
    return {
        state,
        isSubscribed: state === PushSubscriptionState.SUBSCRIBED,
        canToggle: [
            PushSubscriptionState.SUBSCRIBED,
            PushSubscriptionState.READY_TO_SUBSCRIBE
        ].includes(state),
        toggleSubscription
    };
}

//# sourceMappingURL=hooks.js.map